export const defaultFields = () => {
    return [
        {
            key: 'destination_component',
            label: 'Componente de destino',
            sortable: true,
            thStyle: {
                "min-width": "150px !important",
                "width": "150px !important",
            },
        },
        {
            key: 'number_of_unified_components',
            label: 'Cant. componentes unificados',
            sortable: true,
            thStyle: {
                "min-width": "150px !important",
                "width": "150px !important",
            },
        },
        {
            key: 'amount_of_PQ_affected',
            label: 'Cant. Productos afectados',
            sortable: true,
            thStyle: {
                "min-width": "150px !important",
                "width": "150px !important",
            },
        },
        {
            key: 'amount_of_hazards_affected',
            label: 'Cant. Peligros afectados',
            sortable: true,
            thStyle: {
                "min-width": "150px !important",
                "width": "150px !important",
            },
        },        
        {
            key: 'responsible',
            label: 'Responsable',
            sortable: true,
            thStyle: {
                "min-width": "150px !important",
                "width": "150px !important",
            },
        },
        {
            key: 'date',
            label: 'Fecha',
            sortable: true,
            thStyle: {
                "min-width": "100px !important",
                width: "150px !important",
            },
        },
        {
            key: 'actions',
            label: 'Acciones',
            thStyle: {
                "min-width": "100px !important",
                width: "150px !important",
            },
        }
    ];
}

export const dataConfigTable = () => {
    return {
        fields: defaultFields(),
        items: {
            page: 1,
            total: 0,
            current_page: 1,
            per_page: 10,
            data: []
        }
    }
}

export const defaultCurrentUnifyComponent = () => {
    return {
        id: null,
        unify_components_ids: null,
        prod_component_id: null,
        affected_products: [],
        affected_dangers: 0,
        new_components: []
    }
}

export default {

    // Index 
    tableConfig: dataConfigTable(),

    // Formulario
    action: 'CREATE',
    currentUnifyComponent: defaultCurrentUnifyComponent(),
    componentsToPrimaries: []

}
